import { render, staticRenderFns } from "./dataDisplay.vue?vue&type=template&id=11fd824e&scoped=true&"
import script from "./dataDisplay.vue?vue&type=script&lang=js&"
export * from "./dataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./dataDisplay.vue?vue&type=style&index=0&id=11fd824e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd824e",
  null
  
)

export default component.exports